var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_home act-text-stroke",style:({ backgroundColor: _vm.bColor, color: _vm.textColor }),on:{"click":function($event){return _vm.$goPage(_vm.url||'index',{actCode:_vm.$actCode})}}},[_vm._v(" 返回 ")])}
var staticRenderFns = []

export { render, staticRenderFns }